export default {
  path: '/notes',
  name: 'notes',
  meta: { title: '小红书笔记' },
  children: [
    {
      path: '/notes/:type',
      name: 'notesIndex',
      component: () => import('@/views/notes/index.vue'),
      meta: { title: '小红书笔记', subTitle: '场景化种草，精准触达目标用户', key: 'notes' },
    },
  ],
};
